import styled from '@emotion/styled'
import _ from 'lodash'
import { FeatureDict, selectFeatureIncludes } from '@authed/selectors'
import { useAppSelector } from '@redux/hooks'
import {
  AccountSelectionBuilder,
  DataSelectionBuilder,
  FieldMappingBuilder,
  IntegrationFormField,
  IntegrationFormManager,
  IntegrationNameBuilder,
  SyncScheduleBuilder,
  IntegrationFiltersBuilder,
} from '../components'
import {
  INTEGRATION_TYPE,
  DATA_TYPE_KEY,
  FACEBOOK_MARKETING_DATA_TYPES,
} from './components/field-configs'
import { CheckboxFieldBuilder } from '../components/integration-form-manager/integration-form-builders/checkbox-field-builder'

const FullWidth = styled.div`
  width: 100%;
`

export function FacebookMarketing({ assignment }) {
  const [PERFORMANCE_METRICS_ENABLED = false] = useAppSelector(
    selectFeatureIncludes([FeatureDict.PERFORMANCE_METRICS]),
  )

  const integrationFieldsFilter = field =>
    _.get(field, 'fieldTypes', [])
      .map(row => row.type)
      .includes(assignment.metadata[DATA_TYPE_KEY])

  const integrationNameField = new IntegrationNameBuilder().build()
  const accountSelectionField = new AccountSelectionBuilder()
    .resetOnChange(true)
    .dataType(assignment.metadata[DATA_TYPE_KEY] || FACEBOOK_MARKETING_DATA_TYPES[0].type)
    .build()
  const dataSelectionField = new DataSelectionBuilder()
    .placement(2)
    .dataOptions(FACEBOOK_MARKETING_DATA_TYPES)
    .defaultValue(FACEBOOK_MARKETING_DATA_TYPES[0].type)
    .metadataKey(DATA_TYPE_KEY)
    .resetIntegrationOnChange(true)
    .build()
  const syncScheduleField = new SyncScheduleBuilder().placement(3).build()
  const integrationFilters = new IntegrationFiltersBuilder()
    .placement(4)
    .dataTypeFilter(assignment.metadata[DATA_TYPE_KEY])
    .build()
  const fieldMapping = new FieldMappingBuilder()
    .placement(6)
    .integrationTitle('Facebook Marketing')
    .integrationFieldsFilter(integrationFieldsFilter)
    .dataType(assignment.metadata[DATA_TYPE_KEY] || FACEBOOK_MARKETING_DATA_TYPES[0].type)
    .build()

  const formFields: IntegrationFormField[] = [
    integrationNameField,
    accountSelectionField,
    dataSelectionField,
    syncScheduleField,
    fieldMapping,
    integrationFilters,
  ]

  if (PERFORMANCE_METRICS_ENABLED) {
    const pullPerformanceMetricsField = new CheckboxFieldBuilder()
      .placement(5)
      .label('Pull Performance Metrics')
      .metadataKey('pull_performance_metrics')
      .checked(assignment.metadata.pull_performance_metrics == '1')
      .build()

    formFields.push(pullPerformanceMetricsField)
  }

  return (
    <FullWidth>
      <IntegrationFormManager
        integrationType={INTEGRATION_TYPE}
        integrationAssignment={assignment}
        integrationFields={formFields}
      />
    </FullWidth>
  )
}
